<template>
  <v-row>
    <v-col cols="12">
      <v-card class="rounded-lg white">
        <sanad-tabs></sanad-tabs>
        <v-card-text>
          <v-row>
            <template>
              <v-col cols="12">
                <sanad-item-list-report
                  show-previous-remain="false"
                  show-sum="false"
                  filter-row="true"
                  :filters.sync="filters"
                  :showAccountInTable="false"
                  :sortable="true"
                  :filterable="true"
                  :showRemain="false"
                  :showPreviousRemain="false"
                  :showSum="false"
                  :showLink="true"
                  :headers="headers"
                  :colspan="11"
                >
                  <template v-slot:item.floatAccounts="{ item }">
                    <div v-for="(floatAccountName, i) in getFloatAccountNames(item)" :key="i">
                      {{ floatAccountName }}
                    </div>
                  </template>
                </sanad-item-list-report>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SanadItemListReport from "@/components/mcomponents/report/SanadItemListReport";
import queryBinding from "@/components/m-query-binding";
import AccountMixin from "@/mixin/accountMixin";
import SanadTabs from "@/views/panel/sanad/SanadTabs";
export default {
  name: "SanadItemsList",
  mixins: [queryBinding, AccountMixin],
  components: {SanadTabs, SanadItemListReport },
  data() {
    return {
      filters: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("جزئیات اسناد حسابداری")
    },
    headers() {
      return [
        {
          text: "عطف",
          value: "sanad.local_id",
        },
        {
          text: "شماره سند",
          value: "sanad.code",
        },
        {
          text: "تاریخ",
          value: "sanad.date",
          type: "date",
        },
        {
          text: "سیستمی",
          value: "sanad.is_auto_created",
          type: "boolean",
        },
        {
          text: "کاربر",
          value: "created_by.name",
        },
        {
          text: "شرح",
          value: "sanad.explanation",
        },
        {
          text: "شرح ردیف",
          value: "explanation",
        },
        {
          text: "کد حساب",
          value: "account.code",
        },
        {
          text: "نام حساب",
          value: "account.name",
        },
        {
          text: "شناور ها",
          value: "floatAccounts",
          hideInExport: true,
        },
        {
          text: "شناور یک",
          value: "floatAccount1.name",
          show: false,
        },
        {
          text: "شناور دو",
          value: "floatAccount2.name",
          show: false,
        },
        {
          text: "شناور سه",
          value: "floatAccount3.name",
          show: false,
        },
        {
          text: "شناور چهار",
          value: "floatAccount4.name",
          show: false,
        },
        {
          text: "بدهکار",
          value: "bed",
          type: "numeric",
        },
        {
          text: "بستانکار",
          value: "bes",
          type: "numeric",
        },
        {
          text: "مشاهده سند",
          value: "detail",
          sortable: false,
          filterable: false,
          align: "left",
          hideInExport: true,
          show: this.showLink,
        },
      ];
    },
  },
  created() {
    this.filters = this.getFiltersTemplate();
  },
  methods: {
    getFiltersTemplate() {
      return {
        financial_year: this.financialYear.id,
        account_title: "",
        account__code__startswith: "",
        floatAccount__floatAccountGroups: null,
        costCenter__floatAccountGroups: null,
        title: this.title,
      };
    },
    getFloatAccountNames(item) {
      let floatAccounts = [];
      for (const floatAccountType of this.floatAccountTypes) {
        if (item[floatAccountType.key]) {
          floatAccounts.push(item[floatAccountType.key].name);
        }
      }
      return floatAccounts;
    },
  },
};
</script>

<style scoped lang="scss"></style>
